// Tags that occupy their own line in the rich-text editor. TipTap's StarterKit
// (see components/Notes/note/RichTextEditor.tsx) can emit every one of these.
export const BLOCK_TAGS = new Set([
  'p',
  'div',
  'blockquote',
  'pre',
  'ul',
  'ol',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
]);
export const LIST_ITEM_TAG = 'li';
export const LINE_BREAK_TAG = 'br';
export const LIST_ITEM_PREFIX = '- ';
